import gql from "graphql-tag";

export const List = gql`
  query ListCompetitions(
    $filter: TableCompetitionFilterInput,
    $limit: Int,
    $nextToken: String
  )
  {
  listCompetitions(filter: $filter, limit: $limit, nextToken: $nextToken) {
    nextToken
    items {
      competitionId
      code 
      date 
      beginTime
      endTime
      organizer
      teamMemberLimit
      participantLimit
      participantCount
      robotRequired
      published
      event {
        id
        title
        type
      }
      difficulty
      i18n_description
      i18n_title
      price
      coupons
      competitionType
      attemptsLimit
      attemptMaxLengthInSeconds
      concurrentCompetitors
      rrtCompetitorsInGroupMin
      rrtCompetitorsInGroupMax
      rrtCompetitorsInGroupAdvancing
      rrtConcurrentGroups
      rrtConcurrentGroupGames
      tournament {
        competitionId
        beginTime
        lunchBeginTime
        lunchEndTime
        area
        sector
        timeOffsetInMinutes
        hasMatches
      }
    }
  }
}
`;

export const Get = gql`
  query GetCompetition($eventId: ID!, $competitionId: ID!) {
    getCompetition(eventId: $eventId, competitionId: $competitionId) {
      competitionId
      code 
      date 
      beginTime
      endTime
      organizer
      competitionRulesURL 
      teamMemberLimit
      participantLimit
      robotRequired
      published
      event {
        id
        title
        beginDate
        endDate
        type
      }
      difficulty
      i18n_description
      i18n_title
      createdBy
      createdAt
      price
      coupons
      competitionType
      attemptsLimit
      attemptMaxLengthInSeconds
      concurrentCompetitors
      rrtCompetitorsInGroupMin
      rrtCompetitorsInGroupMax
      rrtCompetitorsInGroupAdvancing
      rrtConcurrentGroups
      rrtConcurrentGroupGames
    }
  }
`;


export const Create = gql`
  mutation CreateCompetition($input: CreateCompetitionInput!) {
    createCompetition(input: $input) {
      code 
      date 
      beginTime
      endTime
      organizer
      competitionRulesURL 
      teamMemberLimit
      participantLimit
      robotRequired
      published
      difficulty
      i18n_description
      i18n_title
      price
      coupons
      event {
        id
      }
    }
  }
`;


export const Update = gql`
  mutation UpdateCompetition($input: UpdateCompetitionInput!) {
    updateCompetition(input: $input) {
      competitionId
      code 
      date 
      beginTime
      endTime
      organizer
      competitionRulesURL 
      teamMemberLimit
      robotRequired
      published
      difficulty
      i18n_description
      i18n_title
      price
      coupons
      event {
        id
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/private/admin/containers/Competitions/graphql.js